import { TrackType } from '../constants/trainingConstants';

interface CountableTrack {
  trackType?: string;
  items?: unknown[] | null;
  personaConfig?: { agendaItems?: unknown[] | null } | null;
}

/**
 * How many knowledge-base items a track trains on. A Sales Playbook track
 * keeps them as its AI customer's agenda (personaConfig.agendaItems), never in
 * items[], so counting items[] showed 0 for every playbook track.
 */
export const trainingTrackItemCount = (track: CountableTrack | null | undefined): number => {
  if (track?.trackType === TrackType.PLAYBOOK) return track?.personaConfig?.agendaItems?.length ?? 0;
  return track?.items?.length ?? 0;
};
